<template>
  <div id="app" class="w-100 h-100 p-3">
    <div id="screen" class="d-flex flex-column align-items-center h-100">
      <!-- Header -->
      <h1 class="unselectable-text text-dark">3T Tic Tac Toe Engine Demo</h1>
      <h4 class="unselectable-text text-dark">By: Ameer Taweel</h4>
      <div v-show="isReady">
        <button type="button" class="btn btn-dark m-2" @click="newGame">New Game</button>
        <button type="button" class="btn btn-dark m-2" @click="reset">Reset</button>
        <a href="https://github.com/AmeerTaweel/3T-Engine" target="_blank" class="btn btn-dark m-2" rel="noopener">GitHub Repository</a>
      </div>
      <!-- Canvas -->
      <div class="m-4 flex-grow-1" v-if="!isReady">
        <div class="w-100 h-100 d-flex justify-content-center align-items-center">
          <h1 class="unselectable-text text-dark">Loading...</h1>
        </div>
      </div>
      <div id="canvas" class="m-4 flex-grow-1 bg-white rounded border border-dark" v-show="isReady">
        <div class="w-100 h-100 d-flex flex-wrap">
          <div class="cell d-flex justify-content-center align-items-center display-1 border border-dark unselectable-text text-dark" v-for="(cell, i) in gameDisp" :key="i" @click="userInput(i)">{{cell}}</div>
        </div>
      </div>
      <!-- Results -->
      <h1 class="unselectable-text text-dark">
        <span v-for="(result, i) in results" :key="i">
          {{result.text}}: {{result.num}} <span v-if="i < 2">|</span>
        </span>
      </h1>
    </div>
  </div>
</template>

<script>
import * as tf from '@tensorflow/tfjs'

export default {
  name: `app`,
  data() {
    return {
      isReady: false,
      model: {},
      gameDisp: [],
      game: [],
      types: [],
      blockUserInput: true,
      results: [{text: `Player`, num: 0}, {text: `Tie`, num: 0}, {text: `Computer`, num: 0}]
    }
  },
  methods: {
    maintainAspectRatio() {
      const screen = document.getElementById(`screen`)
      const canvas = document.getElementById(`canvas`)
      if(!(screen.offsetHeight > screen.offsetHeight)){
        canvas.style.width = `${canvas.offsetHeight}px`
        if (canvas.offsetHeight > screen.offsetWidth) {
          canvas.style.width = `${screen.offsetWidth}px`
          canvas.style.height = `${screen.offsetWidth}px`
        }
      }else {
        canvas
      }
    },
    newGame() {
      this.blockUserInput = true
      this.gameDisp = new Array(9).fill(``)
      this.game = new Array(9).fill(0)
      const pTypes = [{ num: 1, disp: `X` }, { num: 2, disp: `O` }]
      const rTypes = [[0, 1], [1, 0]]
      const cTypes = rTypes[Math.round(Math.random())]
      this.types = [pTypes[cTypes[0]], pTypes[cTypes[1]]]
      if(this.types[0].num === 1) {
        this.userTurn()
      }else{
        this.modeTurn()
      }
    },
    userTurn() {
      this.blockUserInput = false
    },
    userInput(i) {
      if(!this.blockUserInput && this.game[i] === 0) {
        this.fillCell(i, this.types[0])
        this.blockUserInput = true
        if(this.getGameStatus() === 0){
          this.modeTurn()
        }else {
          this.updateResults()
        }   
      }
    },
    getFeatures(){
      const example = new Array(this.game.length).fill(0)
      const p_type = this.types[1].num
      for(let i = 0; i < this.game.length;i++){
        const cell = this.game[i]
        if(cell === p_type){
          example[i] = 1
        }else if(cell !== p_type && cell !== 0){
          example[i] = 2
        }
      }
      return example
    },
    modeTurn() {
      const example = this.getFeatures()
      const tensor = tf.tensor(example, [1, 9])
      const rawPrediction = this.model.predict(tensor)
      const classValues = rawPrediction.dataSync()
      const arrayPrediction = Array.from(classValues)
      const prediction = arrayPrediction.indexOf(Math.max(...arrayPrediction))
      this.fillCell(prediction, this.types[1])
      if(this.getGameStatus() === 0){
        this.userTurn()
      }else {
        this.updateResults()
      }
    },
    fillCell(i, type) {
      this.$set(this.gameDisp, i, type.disp)
      this.$set(this.game, i, type.num)
    },
    arraysEqual(a, b) {
      if (a === b) return true
      if (a == null || b == null) return false
      if (a.length != b.length) return false

      for (var i = 0; i < a.length; ++i) {
        if (a[i] !== b[i]) return false
      }
      return true
    },
    getGameStatus(){
      const X_WINS = new Array(3).fill(1)
      const O_WINS = new Array(3).fill(2)
      const threes = [[0, 1, 2], [3, 4, 5], [6, 7, 8], [0, 3, 6], [1, 4, 7], [2, 5, 8], [0, 4, 8], [2, 4, 6]]
      for(let i = 0; i < threes.length; i++) {
        const values = []
        for(let j = 0; j < threes[i].length; j++){
          values.push(this.game[threes[i][j]])
        }
        if(this.arraysEqual(values, X_WINS)){
          return 1
        }else if(this.arraysEqual(values, O_WINS)){
          return 2
        }
      }
      for(let i = 0; i < this.game.length; i++){
        if(this.game[i] === 0){
          return 0
        }
      }
      return 3
    },
    updateResults(){
      const stat = this.getGameStatus(this.game)
      if(stat === this.types[0].num){
        this.results[0].num++
      }else if (stat === this.types[1].num){
        this.results[2].num++
      }else {
        this.results[1].num++
      }

    },
    reset(){
      this.results = [{text: `Player`, num: 0}, {text: `Tie`, num: 0}, {text: `Computer`, num: 0}]
      this.newGame()
    }
  },
  created() {
    // Load trained model
    tf.loadLayersModel(`https://firebasestorage.googleapis.com/v0/b/ttt-engine.appspot.com/o/model.json?alt=media&token=b2921d75-16b9-4c99-b4b2-b5de8cad09d8`).then((model) => {
      this.model = model
      this.isReady = true
      this.newGame()
    })
  },
  mounted() {
    this.$nextTick(() => {
      // The whole view is rendered, so the DOM can be accessed safely
      this.maintainAspectRatio()
      window.addEventListener("resize", () => {
        this.maintainAspectRatio()
      })
    })
  },
  updated() {
    this.$nextTick(() => {
      // The whole view is rendered, so the DOM can be accessed safely
      this.maintainAspectRatio()
      window.addEventListener("resize", () => {
        this.maintainAspectRatio()
      })
    })
  }
}
</script>

<style lang="sass">
// Theme
$primary-color: #FFEB3B

#app
	font-family: 'Avenir', Helvetica, Arial, sans-serif
	-webkit-font-smoothing: antialiased
	-moz-osx-font-smoothing: grayscale
	text-align: center
	background-color: $primary-color
	overflow: scroll

.cell
	width: (1 / 3) * 100%
	height: (1 / 3) * 100%

.unselectable-text
  -webkit-user-select: none /* Safari */        
  -moz-user-select: none /* Firefox */
  -ms-user-select: none /* IE10+/Edge */
  user-select: none /* Standard */
</style>
